/** Collections */
export const GET_COLLECTIONS = 'GET_COLLECTIONS';
export const GET_COLLECTIONS_SUCCESS = 'GET_COLLECTIONS_SUCCESS';

export const COLLECT_RESERVE = 'COLLECT_RESERVE';
export const COLLECT_LOAD = 'COLLECT_LOAD';

export const GET_COLLECTION_HISTORY = 'GET_COLLECTION_HISTORY';
export const GET_COLLECTION_HISTORY_SUCCESS = 'GET_COLLECTION_HISTORY_SUCCESS';